module.exports = __webpack_public_path__ + "img/skilift_logo.f59a99c7.svg";